<app-entity-page
    [closeClicked]="closeClicked"
    [switchToMapTab]="switchToMapTab"
    [detailsContentTitle]="getDetailsTitle()"
    [mapContentTitle]="'iaa.general.map' | translate"
    [loading]="sectionDetailsLoading">
    <ng-template #detailsContent>
        <div class="hb-section-content">
            <app-hb-section-details
                [details]="sectionDetails"
                [findings]="visibleFindings"
                [inReportOnly]="inReportOnly"
                [withPhotosOnly]="withPhotosOnly"
                [selectedEntityId]="selectedEntityId"
                [currentLanguage]="currentLanguage$"
                (inReportOnlyChange)="setInReportOnly($event)"
                (withPhotosOnlyChange)="setWithPhotosOnly($event)"
                (highlightFinding)="highlightFinding($event)">
            </app-hb-section-details>
        </div>
    </ng-template>

    <ng-template #mapContent>
        <div class="hb-section-map">
            <ul #legendBox class="map-legend" [attr.aria-label]="'iaa.app.hbSection.legend.title' | translate">
                <li *ngFor="let item of legend">
                    <span class="swatch" aria-hidden="true" [style.background-color]="item.color"></span>
                    {{ item.label | translate }}
                </li>
            </ul>
            <app-arcgis-map [shapes]="shapes" [mapControls]="mapControls" [extentAll]="true"
                [selectedEntityId]="selectedEntityId" [keepZoomOnSelect]="true"
                (viewReady)="reserveLegendSpace($event, legendBox)"></app-arcgis-map>
        </div>
    </ng-template>

    <ng-template #footer>
        <div class="actions-footer" *ngIf="sectionDetails?.reportUrl">
            <p-button
                styleClass="icon-button"
                [ngClass]="{'icon-button': true, 'en': (currentLanguage$ | async) === 'en'}"
                [link]="true"
                [label]="'iaa.app.hbSection.yazamReport' | translate"
                [ariaLabel]="('iaa.app.hbSection.yazamReport' | translate) + ' (' + ('iaa.aria.opensInNewTab' | translate) + ')'"
                [tabindex]="0"
                (click)="openYazamReport()">
                <ng-template pTemplate="icon">
                    <span class="p-button-icon-left report-icon" aria-hidden="true"></span>
                </ng-template>
            </p-button>
        </div>
    </ng-template>
</app-entity-page>
